import CommonSaveData from "../../LTGame/Commom/CommonSaveData";
import { CmpXDragHandle } from "../../LTGame/UIExt/Cmp/CmpXDragHandle";
import BaseUIMediator from "../../LTGame/UIExt/FGui/BaseUIMediator";
import FGuiEx from "../../LTGame/UIExt/FGui/FGuiEx";
import UI_Fight from "../../ui/Main/UI_Fight";
import GameData from "../common/GameData";
import GlobalUnit from "../common/GlobalUnit";
import AudioManager from "../manager/AudioManager";
import LTPlatform from "../../LTGame/Platform/LTPlatform";
import { EPlatformType } from "../../LTGame/Platform/EPlatformType";
export class UI_FightMediator extends BaseUIMediator {
    static get instance() {
        if (this._instance == null) {
            this._instance = new UI_FightMediator();
            this._instance._classDefine = UI_Fight;
        }
        return this._instance;
    }
    _OnShow() {
        super._OnShow();
        this.xDragCmp = new CmpXDragHandle(this.ui.m_img_bg);
        this.ui.m_btn_sound.onClick(this, this.SetSound);
        this.ui.m_btn_viberate.onClick(this, this.SetViberate);
        this.ui.m_btn_viberate.visible = LTPlatform.instance.platform != EPlatformType.Web4399;
        this.UpdateBarPos();
        this.UpdateBarValue();
        this.RefreshUI();
        this.RefreshBtnUI();
        if (GlobalUnit.game.level.config.level_type == 4) {
            this.HideBar();
        }
        else {
            this.ShowBar();
        }
        LTPlatform.instance.ShowBannerAd();
    }
    RefreshUI() {
        if (GlobalUnit.game.level.config.level_type == 2 || GlobalUnit.game.level.config.level_type == 3) {
            this.ui.m_com_level.visible = false;
        }
        else if (GlobalUnit.game.level.config.level_type == 4 || GlobalUnit.game.level.config.level_type == 5) {
            this.ui.m_com_level.visible = true;
            this.ui.m_com_level.m_text_level.text = "t";
        }
        else {
            this.ui.m_com_level.visible = true;
            this.ui.m_com_level.m_text_level.text = "l" + GlobalUnit.game.level.config.id;
        }
        this.ui.m_com_coin.m_text_count.text = GameData.instance.coinCount.toString();
    }
    SetSound(e) {
        e.stopPropagation();
        if (GlobalUnit.game.level.config.level_type == 4) {
            AudioManager.instance.PlayById(15);
        }
        else {
            AudioManager.instance.PlayById(1);
        }
        CommonSaveData.instance.isMusicOn = !CommonSaveData.instance.isMusicOn;
        if (!CommonSaveData.instance.isMusicOn) {
            AudioManager.instance.Pause();
        }
        else {
            AudioManager.instance.Resume();
        }
        this.RefreshBtnUI();
    }
    SetViberate(e) {
        e.stopPropagation();
        AudioManager.instance.PlayById(1);
        CommonSaveData.instance.isShakeOn = !CommonSaveData.instance.isShakeOn;
        this.RefreshBtnUI();
    }
    RefreshBtnUI() {
        if (CommonSaveData.instance.isShakeOn) {
            this.ui.m_btn_viberate.icon = "ui://c6t3i6k8jh461h";
        }
        else {
            this.ui.m_btn_viberate.icon = "ui://c6t3i6k8jh461i";
        }
        if (CommonSaveData.instance.isMusicOn) {
            this.ui.m_btn_sound.icon = "ui://c6t3i6k8jh461e";
        }
        else {
            this.ui.m_btn_sound.icon = "ui://c6t3i6k8jh461f";
        }
    }
    HideBar() {
        this.ui.m_com_year.visible = false;
    }
    ShowBar() {
        this.ui.m_com_year.visible = true;
    }
    UpdateBarPos() {
        let pos = FGuiEx.GetPointFrom3DWorld(GlobalUnit.game.camera.camera, GlobalUnit.game.player.GetRootPos(), this.ui);
        this.ui.m_com_year.x = pos.x;
        this.ui.m_com_year.y = pos.y - 200;
    }
    UpdateBarValue() {
        let year = GlobalUnit.game.player.currYear;
        this.ui.m_com_year.m_text_year.text = Math.floor(year).toString();
    }
    ClickStart(e) {
        e.stopPropagation();
    }
    _OnHide() {
        this.xDragCmp.Dispose();
        LTPlatform.instance.HideBannerAd();
    }
}
